import React, { Component } from "react";
import styled, { css } from "styled-components";
import { Link } from "react-router-dom";

//components
import {Accordion, AccordionItem, 
		AccordionItemHeading, AccordionItemButton, 
		AccordionItemPanel} from 'react-accessible-accordion';
import '../components/react-accessible-accordion-mystyle.css';
import DynamicBoard from "../components/DynamicBoard";
import ColorPicker from "../components/ColorPicker";
import Button from "../components/Button";
import {ColorToNumberDict, NumberToColorDict} from "../components/ColorToNumberDict";

import instructionSheets from "../data/instructionSheets";

class VAlign extends Component {
	constructor(props) {
		super(props);
	
  this.state = {currentColor: "white",
    currentStep: "Click START to start carrying out the drawing steps one by one",
    currentStepIdx: 0,
    taskDisplayCompleted: false,
	
	// keep the board state in an array which is initialized to all white
	// the board contains 180 tiles. the array contains 181 elements (0-180) - the zero element is ignored
	boardState: Array(181).fill (0),
	
  //This is the user output, that is, the steps he did in accomplishing the task.
  //  it includes: triplets of (line number, line instructions, boardstate}
	userSteps: [],
	
	//documenting each user action
	actions:[],
	//dcumenting all the tiles clicked betweeen two colors
	memoryTiles:[]
	};
	
	this.setColor = this.setColor.bind(this);
	this.updateUserSteps = this.updateUserSteps.bind(this);
	this.showNextLine = this.showNextLine.bind(this);
	this.updateBoardState = this.updateBoardState.bind(this);
	this.handleDone = this.handleDone.bind (this);
  
  }
  
//updating the color from ColorPicker
//updating the actions with the previous color and its associated tiles. 
setColor = newColor => {
	let updatedActions = [...this.state.actions, [this.state.currentColor,this.state.memoryTiles]]
	this.setState({ currentColor: newColor,
					actions:updatedActions,
					memoryTiles:[]
					});
  };
 
//update user output when clicking NEXT 
 updateUserSteps = (props) => {
	 
	 //update actions (same as in setColor function)
	 let updatedActions = [...this.state.actions, [this.state.currentColor,this.state.memoryTiles]]
	 this.setState({actions:updatedActions, memoryTiles:[]});
	 
	 //update user output
	 let lineIndex = this.state.currentStepIdx-1;
	 let currentLine = {"line_number":lineIndex+1, // the number of the line in the instruction sheet
						"line_instruction":instructionSheets[this.props.taskUserId]["instruction_sheet"][lineIndex], //line of instruction
						"board_state": this.state.boardState, // this is the board state after user implement the instructions
						"actions":updatedActions
						}
	 let updated1 = this.state.userSteps.concat(currentLine);
	 this.setState ( {userSteps:updated1, actions:[]} );
	 
	 //reset actions
	 this.setState({actions:[]})
};
  
showNextLine = props => {
    
	this.updateUserSteps();
		
	if (this.state.currentStepIdx < instructionSheets[this.props.taskUserId]["instruction_sheet"].length) {
      this.setState({
		currentStepIdx: this.state.currentStepIdx + 1,
        currentStep: this.state.currentStepIdx+1 + ". " + instructionSheets[this.props.taskUserId]["instruction_sheet"][this.state.currentStepIdx]
      });
    } else {
      this.setState({ 
	  currentStep: "You are done, please click DONE",
	  taskDisplayCompleted: true,
	  currentStepIdx: this.state.currentStepIdx + 1	
	  });
      return;
    }
	
};
  
// update the board state array each time an hexagon is clicked 
//hexagon[0] is the tile number, hexagon[1] is the tile color which can be this.state.currentColor or white (in case of double click)
updateBoardState (hexagon){
	let updated = this.state.boardState.slice(); //make a copy
    updated[hexagon[0]] =ColorToNumberDict[hexagon[1]]; 
	this.setState({boardState:updated}); //replace the boardState array with the updated one
	
	//updated the memoryTiles: keep the clicked tile under the current color
	let updatedTiles = [...this.state.memoryTiles, hexagon[0]]
	this.setState({memoryTiles:updatedTiles});
};

  
//when user click DONE then Align screen sends the final userSteps to App and the last step index. 
handleDone () { 

//updating userSteps (similar to updateUserSteps) to include actions in the Done step (=actions that were done after unfolding all the drawing steps). 
	 let updatedActions = [...this.state.actions, [this.state.currentColor,this.state.memoryTiles]]
	 this.setState({actions:updatedActions, memoryTiles:[]});
	 //update user output
	 let lineIndex = this.state.currentStepIdx-1;
	 let currentLine = {"line_number":lineIndex+1, // the number of the line in the instruction sheet
						"line_instruction":"You are done, please click DONE", //line of instruction
						"board_state": this.state.boardState, // this is the board state after user implement the instructions
						"actions":updatedActions
						}
	 let updated1 = this.state.userSteps.concat(currentLine);
	 this.setState ( {userSteps:updated1, actions:[]} );
	 //reset actions
	 this.setState({actions:[]})

//render the currenStepIdx that show of the Done step (final step is currentStepIdx-1)
this.props.getFinalUserSteps ([updated1,this.state.currentStepIdx]) 


}
   
  
  
	render() {
    return (
	<Container>
				
		{/*Tips*/}
		<Accordion className="none" allowZeroExpanded = {true} style={{display:"block"}}>
			<AccordionItem>
				<AccordionItemHeading style={{fontSize: "14px", width: "110px"}}>
					<AccordionItemButton>
						See Tips Here
					</AccordionItemButton>
				</AccordionItemHeading>
				<AccordionItemPanel style={{fontSize:"12px", width: "60vw" }}>
					<ul>								
						<li> Carry out your drawing steps one by one by drawing on the 
						Hexagon Board on the right side of the screen </li>
						<li> The current drawing step is displayed on the left side of the screen, 
						and is marked in yellow</li>
						<li> Make sure you are carrying out ONLY the current drawing step</li> 
						<li> After you clicked NEXT you cannot revise your painting 
						for the previous drawing step </li>
						<li> To draw on the Hexagon Board choose a color from the palette and click on tiles </li>
						<li> The color palette includes the following colors: &nbsp;
								<mark style ={{backgroundColor:NumberToColorDict[2]}}>Yellow</mark>,&nbsp;
								<mark style ={{backgroundColor:NumberToColorDict[7]}}>Orange</mark>,&nbsp;
								<mark style ={{backgroundColor:NumberToColorDict[4]}}>Red</mark>,&nbsp;
								<mark style ={{backgroundColor:NumberToColorDict[6]}}>Purple</mark>,&nbsp;
								<mark style ={{backgroundColor:NumberToColorDict[5]}}>Blue</mark>,&nbsp;
								<mark style ={{backgroundColor:NumberToColorDict[3]}}>Green</mark>,&nbsp; 
								<mark style ={{backgroundColor:NumberToColorDict[1], color:"white"}}>Black</mark>, and 
								White 
								</li>
						<li> Double click on the same tile deletes its color </li>							
					</ul>					
				</AccordionItemPanel>
			</AccordionItem>	
		</Accordion>
		
		<Container primary>			
			
		  <Container style={{margin:"0em"}}>
			{/*Instructions*/}
			<Container style={{background:"white", width: "40vw", overflow: "scroll", maxHeight: "60vh", minHeight: "60vh"}}>
				
				{/*previous steps */}
				<InstructionSheetList 
					instructionSheet ={
						(this.state.currentStepIdx==0 ? [] : instructionSheets[this.props.taskUserId]["instruction_sheet"].slice(0,this.state.currentStepIdx-1)  )
					} 
				/>
				{/*current steps */}	
				<mark style = {{background:"yellow", margin: "0.8em 1.5em"}}>  
					{this.state.currentStep} 
				</mark>				
			</Container>
			
			{/* buttons */}
			<ButtonContainer>
				<StyledButton
					onClick= {this.state.taskDisplayCompleted? null : this.showNextLine}
					className={this.state.taskDisplayCompleted? "inactive-btn" : "active-btn"}
				 >
					{this.state.currentStepIdx==0 ? "Start" : "Next"}
				</StyledButton>
				
				<StyledButton
				onClick= {this.state.taskDisplayCompleted? this.handleDone : null}
				className={this.state.taskDisplayCompleted? "active-btn": "inactive-btn"}
				>
					<RedirectLink to={this.state.taskDisplayCompleted? this.props.linkFromAlign : null}>
						Done
					</RedirectLink>
				</StyledButton>
			</ButtonContainer>
		  </Container>		
				{/*board*/}
			<Container style={{background:"white", width: "50vw"}}>
				<ColorPicker
				passColorToParent={this.setColor}
				currentColor={this.state.currentColor}
				/>
				<DynamicBoard
				currentColor={this.state.currentColor} // Pass color to Board
				HexagonState = {this.updateBoardState}
				NumberedBoard = {instructionSheets[this.props.taskUserId]["numberedBoard"]}	
				/>
					
			</Container>
		</Container>
		
	</Container>
	);
	}
}

export default VAlign;

const instructionSheetDemo = instructionSheets["Task02_03dNLab"]

//break the instructions into numbered list
function InstructionSheetList(props){
	const instructionSheet = props.instructionSheet
	const listItems = instructionSheet.map((item) =>
    <li key={item.key}>{item}</li> 
  );
  return (
    <ol>{listItems}</ol>
  );
}
							
							
const Container = styled.div`
margin: 0.5em;
width: ;
text-align: left;
display: flex;
flex-direction: column;


${props => props.primary && css `  
   flex-direction: row; 
	  
  `}

`;						
							
							
const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-around;
  width: 40vw;
`;

const StyledButton = styled(Button)`
  width: 20%;
`;



const RedirectLink = styled(Link)`
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0);
  width: 100%;
  height: 50px;
  line-height: 50px;
  text-align:center;
  border-radius: 4px;
  text-decoration: none;
  color: inherit;
  #background: red;

  transition: all 300ms;

  &:focus,
  &:hover,
  &:visited,
  &:link,
  &:active {
    text-decoration: none;
  }
`;							
							
							
							
							
							